import script from "./call-notification.vue?vue&type=script&setup=true&lang=js"
export * from "./call-notification.vue?vue&type=script&setup=true&lang=js"

import "./call-notification.scss?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__